import { useLang } from "@/context/LangContext";

const Marquee = () => {
  const { lang } = useLang();
  const items =
    lang === "en"
      ? [
          "Done-For-You Product Launches",
          "Revenue Share Partnership",
          "Zero Upfront Investment",
          "Built For Creators",
          "Proven Launch Systems",
          "Audience-First Strategy",
        ]
      : [
          "Lancements clé en main",
          "Partage de revenus",
          "Aucun frais initial",
          "Conçu pour les créateurs",
          "Systèmes éprouvés",
          "Stratégie centrée audience",
        ];
  const doubled = [...items, ...items, ...items];

  return (
    <div className="relative py-14 overflow-hidden border-y border-white/[0.05] bg-po-surface/30">
      <div className="flex animate-marquee gap-12 whitespace-nowrap" data-testid="marquee">
        {doubled.map((it, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className="font-display text-2xl md:text-4xl tracking-tight text-white/80">{it}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-po-accent shadow-[0_0_10px_rgba(16,185,129,0.8)]" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
